/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-parent[_ngcontent-%COMP%] {\n  background: #ffffff;\n  padding: 20px 50px 50px 50px;\n  border-radius: 10px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.company-dropdown[_ngcontent-%COMP%] {\n  padding-right: 15px;\n  min-width: 250px;\n  max-width: 250px; }\n\n.year-dropdown[_ngcontent-%COMP%] {\n  min-width: 80px;\n  max-width: 80px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-sms/dashboard-sms.component.scss.shim.ngstyle.js.pre-build-optimizer.js